export default __webpack_public_path__ + "static/media/list-view-active.43c723bb.svg";